import { axiosInstance } from "@/lib/api/client";
import { MIME_TYPE_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { FormConfiguration } from "@rumble-it/common-lib/types/formConfiguration.interface";

interface GetFormConfigurationResponse {
  formConfiguration: FormConfiguration;
  etag: string | null;
}

export const getFormConfiguration = async (
  formConfigurationId: string,
): Promise<GetFormConfigurationResponse> =>
  axiosInstance
    .get<FormConfiguration>(
      `/form-configurations/${formConfigurationId}/serve`,
      {
        headers: {
          Accept: MIME_TYPE_JSON,
          "Content-Type": MIME_TYPE_JSON,
        },
      },
    )
    .then((response) => ({
      formConfiguration: response.data,
      etag: response.headers["etag"] ?? null,
    }));
